import FilterDialog from './Dialog'
import { useSelector } from 'react-redux'
import FilterButton from '../../../../../../../filter/FilterButton'

const FilterButtonLearningMatrix = ({ chartType }) => {
  const open = useSelector((state) => state?.filter?.learningMatrix?.open || false)

  return (
    <>
      <FilterButton
        module='learningMatrix'
        keysFilter={[
          'rolesId',
          'lcElements',
          'ulId',
          'classId',
          'student',
          'yearLevelId',
          'yearLevel',
          'code',
          'firstName',
          'lastName',
          'houseId',
          'house',
          'formId',
          'form',
          'preferredName'
        ]}
      />
      {open && <FilterDialog chartType={chartType} />}
    </>
  )
}
export default FilterButtonLearningMatrix
